import React, { useEffect, useRef } from 'react'
import { App_url, ExperienceList } from '../utils/constants/static'
import { ScrollTrigger } from 'gsap/ScrollTrigger'
import gsap from 'gsap';

gsap.registerPlugin(ScrollTrigger);
const Experience = () => {
    const imgRef = useRef<HTMLDivElement[]>([]);

    useEffect(() => {
        gsap.set(imgRef.current, { opacity: 0 })
    }, [])

    const handleMouseEnter = (index: number) => {
        gsap.to(imgRef.current, {
            opacity: 0,
            duration: 0.6,
            ease: "power2.out",
        });

        gsap.to(imgRef.current[index], {
            opacity: 1,
            duration: 0.6,
            ease: "power2.out"
        });
    }

    const handleMouseLeave = (index: number) => {
        gsap.to(imgRef.current[index], {
            opacity: 0,
            duration: 0.6,
            ease: "power2.out",
        })
    }

    return (
        <div id='experience' className='relative bg-black h-[160vh] w-full bg-cover bg-center bg-no-repeat flex flex-col gap-4 justify-end py-[var(--site--margin)] pb-[30vh] ' style={{ backgroundImage: `url(${App_url.image.list_bg})` }}>
            <div>
                <div className='absolute bottom-[30%] right-[10vw] text-8xl font-[PPEiko] mb-[1rem]'>EXPERIENCE</div>
                <div className='absolute top-10 text-base mx-[var(--site--margin)] uppercase'>Check out our Past events</div>
            </div>
            <div className='absolute flex flex-col w-full'>
                {/* list item */}
                {ExperienceList.map((item, index) => (
                    <div 
                     key={item.id}
                     onMouseEnter={() => handleMouseEnter(index)}
                     onMouseLeave={() => handleMouseLeave(index)}
                     className='flex flex-row gap-[1.6rem] px-[40px] py-[12px] border-t border-t-[#ffffff75] leading-none z-[2] opacity-30 transition-opacity duration-300 ease-in-out mix-blend-difference hover:opacity-100'
                    >
                        <p className='text-base mr-[6rem]'>{item.date}</p>
                        <div className='flex flex-row gap-[1.6rem]'>
                            <p className='font-[PPEiko] text-base italic uppercase'>{item.collect}</p>
                            <p className='text-base uppercase'>{item.name}</p>
                        </div>
                    </div>
                ))}

            </div>
            <div className='fixed top-0 left-0 w-[100vw] h-[100vh] grid [grid-template-columns:calc(100vw_-(10vw_+_(var(--svg-height)*31/8)))_1fr_calc(var(--svg-height)*148/80_-_10vw)_10vw] [grid-template-rows:25%_25%_25%_25%] pointer-events-none z-[4]'>
                {/* Image List */}
                {ExperienceList.map((item, index) => (
                    <div key={item.id}
                        ref={(el) => {
                            imgRef.current[index] = el!
                        }}
                        className=''
                    >
                        <img
                            src={item.image}
                            alt='list1'
                            className='w-full h-full object-cover'
                        />
                    </div>
                ))}
            </div>
        </div>
    )
}

export default Experience

